import { render, staticRenderFns } from "./EquipList.vue?vue&type=template&id=2b4dca71&scoped=true&"
import script from "./EquipList.vue?vue&type=script&lang=js&"
export * from "./EquipList.vue?vue&type=script&lang=js&"
import style0 from "./EquipList.vue?vue&type=style&index=0&id=2b4dca71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dca71",
  null
  
)

export default component.exports